import React from 'react'
import { useSelector } from 'react-redux'
import { toast as toastify, ToastContainer } from 'react-toastify'

import store from 'store'
import Icon from 'icons/Icon'

export const toast = (message, type) => {
  switch (type) {
    case 'success':
      return toastify.success(Toast({ message, title: 'success' }))

    case 'error':
      return toastify.error(Toast({ message, title: 'error' }))

    default:
      return toastify.warning(Toast({ message, title: 'warning' }))
  }
}

const Toast = ({ message, title }) => (
  <>
    <span className='toast-title'>{store ? store?.getState('language')?.language?.languageData?.[title] : ''}</span>

    <span>{message}</span>
  </>
)

/**
 * ToastMessageContainer component renders a toast notification container with configurable settings
 *
 * @returns {JSX.Element} Toast container component with configured settings from Redux store
 */
export const ToastMessageContainer = () => {
  const general = useSelector(state => state?.uiConfig?.general)
  const toastMessageTimeout = general?.toastMessageTimeout || 5000

  return (
    <ToastContainer
      theme='colored'
      position='top-right'
      autoClose={toastMessageTimeout}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      draggablePercent={40}
      pauseOnHover
      icon={({ type }) => {
        switch (type) {
          case 'info':
            return <Icon name='toast-success' />
          case 'error':
            return <Icon name='toast-error' />
          case 'success':
            return <Icon name='toast-success' />
          case 'warning':
            return <Icon name='toast-error' />
          default:
            return null
        }
      }}
    />
  )
}
